<script setup lang="ts">
import { PostFilterBy } from '@/blog/domain/PostFilterBy';
import { computed, ref } from 'vue';
import BaseSelectBlog from '@/blog/infrastructure/components/BaseSelectBlog.vue';

interface Emits {
  (e: 'update:filterBy', filterBy: PostFilterBy): void;
}

interface Props {
  filterBy: PostFilterBy;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const filterBy = ref(props.filterBy);

const filterByOptions = [
  { label: 'Popular', value: PostFilterBy.POPULARITY },
  { label: 'Recent', value: PostFilterBy.RECENT },
];

const selectedSortBy = computed({
  get: () => {
    return (
      filterByOptions.find(opt => opt.value === filterBy.value) ||
      filterByOptions[0]
    );
  },
  set: value => {
    if (value) {
      filterBy.value = value.value;
      emit('update:filterBy', value.value);
    }
  },
});
</script>

<template>
  <BaseSelectBlog
    v-model="selectedSortBy"
    :options="filterByOptions"
    class="hidden md:inline-block"
  />

</template>
